import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { BASE_URL } from "../utilities/BASE_URL";

export const registerUser = createAsyncThunk(
    "register/registerUser",
    async ({ email, password, userName }, { rejectWithValue }) => {
      try {
        const response = await fetch(`${BASE_URL}/autha/register`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password, userName }),
        });
  
        // A 429 (or a proxy error page) may not carry JSON; without this guard the parse
        // failure replaces the server's reason with "Unexpected token ...".
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(data.error || "Registration failed");
        }
  
        localStorage.setItem("token", data.token);
        return data.token;
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  
  const registerSlice = createSlice({
    name: "register",
    initialState: {
      loading: false,
      error: null,
      success: false,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(registerUser.pending, (state) => {
          state.loading = true;
          state.error = null;
          state.success = false;
        })
        .addCase(registerUser.fulfilled, (state) => {
          state.loading = false;
          state.success = true; // ✅ Indicate successful registration
        })
        .addCase(registerUser.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
          state.success = false;
        });
    },
  });
  
  export default registerSlice.reducer;
